<template>
  <div>
    <xer-modal
      v-if="notificationStore.showNotification"
      :xer-title="rootStore.translate(notificationStore.props.titel)"
      :xer-open="notificationStore.showNotification"
      :xer-pictogram="notificationStore.xerModalPictogram"
      :xer-slideout="notificationStore.isSlideOut"
      data-automation-id="modal"
      @xer-close="close()"
    >
      <xer-contact-info-content
        v-if="notificationStore.props.contentType === 'contact-popup'"
        :content="notificationStore.props.content"
      />
      <div
        v-else
        class="xer-documentation"
        v-html="rootStore.translate(notificationStore.props.content)"
      />
    </xer-modal>
  </div>
</template>

<script>
import { XerModal } from '@xerius/codey-components-vue2';
import XerContactInfoContent from '@/components/XerContactInfoContent.vue';
import { useNotificationsStore } from '@/stores/notification/notification.js';
import { useRootStore } from '@/stores/index.js';
import { mapStores } from 'pinia';

export default {
  components: {
    XerModal,
    XerContactInfoContent
  },
  computed: {
    ...mapStores(useNotificationsStore, useRootStore)
  },
  methods: {
    close() {
      this.notificationStore.close();
    }
  }
};
</script>
